<template>
  <div class="precautions">
    <div class="precautions_inner bg-white">
      <p class="text-center text-2xl font-black mb-0" v-if="$route.params.practice_type === 'speaking'">口說測驗說明</p>
      <p class="text-center text-2xl font-black mb-0" v-if="$route.params.practice_type === 'writing'">寫作測驗說明</p>
      <div class="row text-lg font-bold px-2">
        <div class="col-12 col-lg-9">
          <div class="text-left" v-if="$route.name=== 'TOEIC_exam' && $route.params.practice_type === 'speaking'">
            <p>此測驗共五大題:</p>
            <p class="text-blue-main-toeic mb-0">PART 1:朗讀（Read a Text Aloud）</p>
            <p>大聲讀出螢幕上的英文短文，有45秒準備時間及45秒作答時間。這類題型共有兩題。</p>
            <p class="text-blue-main-toeic mb-0">PART 2:描述照片（Describe a Picture）</p>
            <p>根據螢幕上的照片，詳細描述其中出現的人物、場景與所發生的事，細節越詳細越好。這類題型共有兩題，各有45秒準備時間及30秒作答時間。</p>
            <p class="text-blue-main-toeic mb-0">PART 3:回答問題（Respond to Questions）</p>
            <p>依據題目設定的情境，回答與日常生活有關的問題。這類題型共有三題，並無準備時間，請在聽到「嗶」聲後立即作答。第5題、第6題的作答時間各為15秒，第7題為30秒。</p>
            <p class="text-blue-main-toeic mb-0">PART 4:依據題目資料應答（Respond to Questions Using Information Provided）</p>
            <p>依據題目設定的情境與提供的資料回答問題。這類題型共有三題。開始提問前，有45秒可以瀏覽資料，各題之間沒有準備時間，請在聽到「嗶」聲後立即作答。第8題、第9題題目只播放一次，作答時間各為15秒；第10題題目會播放兩次，作答時間為30秒。</p>
            <p class="text-blue-main-toeic mb-0">PART 5:陳述意見（Express an Opinion）</p>
            <p>針對指定的議題陳述意見並提出理由。作答前有45秒的準備時間，作答時間有60秒。</p>
          </div>
          <div class="text-left" v-if="$route.name=== 'TOEIC_bridge' && $route.params.practice_type === 'speaking'">
            <p>此測驗共六大題:</p>
            <p class="text-blue-main-toeic mb-0">PART 1 - Questions1-2:短文朗讀 （Read a Short Text Aloud）</p>
            <p>大聲讀出螢幕上的英文短文，有25秒準備時間及30秒作答時間。這類題型共有兩題。</p>
            <p class="text-blue-main-toeic mb-0">PART 2  - Questions 3-4:照片描述 （Describe a Photograph）</p>
            <p>看螢幕上的照片，詳細描述照片中出現的人物、場景與所發生的事，細節越詳細越好，有30秒準備時間及30秒作答時間。這類題型共有兩題。</p>
            <p class="text-blue-main-toeic mb-0">PART 3  - Questions 5:主旨重述 （Listen and Retell）</p>
            <p>依照題目指定主題，將聽見的資訊轉達給另一人。有15 秒準備時間及30秒作答時間。</p>
            <p class="text-blue-main-toeic mb-0">PART 4 - Questions 6:簡短互動 （Short Interaction）</p>
            <p>使用題目提供的資訊來完成任務，有30秒準備時間及30秒作答時間。</p>
            <p class="text-blue-main-toeic mb-0">PART 5 - Questions 7:故事描述 （Tell a Story）</p>
            <p>題目提供的四張圖片構成一個故事，請用自己的話說出這個故事。故事內容需解釋圖片中發生了什麼事且為何會發生。可描述地點、人物、動作和感覺。有45秒準備時間及60秒作答時間。</p>
            <p class="text-blue-main-toeic mb-0">PART 6 - Questions 8:提議和支持論點 （Make and Support a Recommendation）</p>
            <p>根據題目提供的資訊，向說話對象提出建議並說明原因。有60秒準備時間及60秒作答時間。</p>
          </div>
          <div class="text-left" v-if="$route.name=== 'TOEIC_exam' && $route.params.practice_type === 'writing'">
            <p>此測驗共三大題:</p>
            <p class="text-blue-main-toeic mb-0">PART 1:描述照片 （Write a sentence based on a picture）</p>
            <p>依照圖片內容造出一個句子，句中必須包含指定的兩個單字或片語，指定字詞的型態或使用順序可以變更。這類題型共五題，整個大題作答時間共8分鐘。8分鐘內可以往前題往後題進行作答，進入PART2後即不得再回來作答。</p>
            <p class="text-blue-main-toeic mb-0">PART 2 : 回覆書面要求（Respond to a written request）</p>
            <p>閱讀25~50字的電子郵件後撰寫回信。每封郵件的閱讀與作答時間為10分鐘。這類題型共兩題，進入第2題後則無法返回第1題。</p>
            <p class="text-blue-main-toeic mb-0">PART 3 : 陳述意見（Write an opinion essay）</p>
            <p>針對指定的議題陳述意見，並提出理由及例子作為佐證。作答時間共30分鐘，包含構思、寫作、檢查及修改答案。</p>
          </div>
          <div class="text-left" v-if="$route.name=== 'TOEIC_bridge' && $route.params.practice_type === 'writing'">
            <p>此測驗共五大題:</p>
            <p class="text-blue-main-toeic mb-0">PART 1:句子重組 （Build a Sentence）</p>
            <p>依照圖片內容造出一個句子，句中必須包含指定的兩個單字或片語，指定字詞的型態或使用順序可以變更。這類題型共五題，整個大題作答時間共8分鐘。8分鐘內可以往前題往後題進行作答，進入PART2後即不得再回來作答。</p>
            <p class="text-blue-main-toeic mb-0">PART 2 : 簡短造句（Write a Sentence）</p>
            <p>閱讀25~50字的電子郵件後撰寫回信。每封郵件的閱讀與作答時間為10分鐘。這類題型共兩題，進入第2題後則無法返回第1題。</p>
            <p class="text-blue-main-toeic mb-0">PART 3 : 簡訊回覆 （Respond to a Brief Message）</p>
            <p>針對指定的議題陳述意見，並提出理由及例子作為佐證。作答時間共30分鐘，包含構思、寫作、檢查及修改答案。</p>
            <p class="text-blue-main-toeic mb-0">PART 4 : 敘述文撰寫（Write a Narrative）</p>
            <p>閱讀25~50字的電子郵件後撰寫回信。每封郵件的閱讀與作答時間為10分鐘。這類題型共兩題，進入第2題後則無法返回第1題。</p>
            <p class="text-blue-main-toeic mb-0">PART 5 : 長訊息回復（Respond to an Extended Message）</p>
            <p>針對指定的議題陳述意見，並提出理由及例子作為佐證。作答時間共30分鐘，包含構思、寫作、檢查及修改答案。</p>
          </div>
        </div>
        <div class="TestingTools col-12 col-lg-3">
          <TestingTools_speaking v-if="$route.params.practice_type === 'speaking'" />
          <TestingTools_writing v-if="$route.params.practice_type === 'writing'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TestingTools_speaking from '@/components/AiHelper/toeic/TestingTools_speaking'
  import TestingTools_writing from '@/components/AiHelper/toeic/TestingTools_writing'
  export default {
    // 注意事項
    name: 'Precautions',

    data () {
      return {}
    },
    props: {
    },

    components: {
      TestingTools_speaking,
      TestingTools_writing
    }
  }
</script>

<style lang="scss" scoped>
</style>
